
















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import TextoRicoDoChat from './TextoRicoDoChat.vue'
import { ehAudio, horaDaMensagem, opcoesDaMensagem } from '@/shareds/chat-de-suporte'
import type { MensagemDoChat } from '@/shareds/chat-de-suporte'

@Component({
	components: {
		TextoRicoDoChat,
	},
})
export default class MensagemDoChatDeSuporte extends Vue {
	@Prop({ type: Object, required: true }) mensagem!: MensagemDoChat
	@Prop({ type: Boolean, default: false }) acionavel!: boolean
	@Prop({ type: String, default: null }) escolhida!: string | null
	@Prop({ type: String, default: null }) respondendo!: string | null

	get minha() {
		return this.mensagem.from === 'cliente'
	}

	get atendente() {
		return this.mensagem.from === 'atendente'
	}

	get audio() {
		return ehAudio(this.mensagem)
	}

	get opcoes() {
		return opcoesDaMensagem(this.mensagem)
	}

	get hora() {
		return horaDaMensagem(this.mensagem.sentAt)
	}

	// No áudio o suporte grava o nome do arquivo ou "[audio]" como texto: não é legenda de verdade
	get textoVisivel() {
		return !!this.mensagem.text && !(this.audio && this.rotuloAutomatico(this.mensagem.text))
	}

	get legendaVisivel() {
		return !!this.mensagem.caption && !(this.audio && this.rotuloAutomatico(this.mensagem.caption))
	}

	rotuloAutomatico(texto: string) {
		const limpo = texto.trim()
		const arquivo = this.mensagem.media && this.mensagem.media.filename
		return !limpo
			|| (!!arquivo && limpo.toLowerCase() === arquivo.trim().toLowerCase())
			|| /^\[?(audio|áudio|voice|ptt)\]?$/i.test(limpo)
	}

	rotuloDaOpcao(titulo: string) {
		if (this.acionavel) return titulo
		return `${titulo}, ${this.escolhida === titulo ? 'opção escolhida' : 'opção encerrada'}`
	}
}
